import { WidgetEvent } from "../enums/widget-event.enum";
import { IWidgetNode } from "../interfaces/widget-node.interface";
import fullWidgetStyles from "../styles/full-widget.module.scss";
import fullWidgetContainerStyles from "../styles/full-widget-container.module.scss";
import closeButtonStyles from "../styles/close-button.module.scss";
import mainButtonStyles from "../styles/main-button.module.scss";
import offerStyles from "../styles/offer.module.scss";
import imageStyles from "../styles/image.module.scss";
import { CustomClass } from "../enums/custom-class.enum";
import { IFixBlockOptions } from "../../../interfaces/fix-block-options.interface";
import { EventEmitter } from "../../../components/event-emitter";

export class FullWidgetNode implements IWidgetNode {
  constructor(
    private readonly options: IFixBlockOptions,
    private readonly clickEmitter: EventEmitter<WidgetEvent>
  ) { }

  private fullWidget: HTMLDivElement;

  public appendToPage(): void {
    this.fullWidget = document.createElement("div");
    this.fullWidget.dataset.nameSpace = "dentolo";
    this.fullWidget.id = "dentolo_wide-widget";
    this.fullWidget.className = fullWidgetStyles.default;
    this.fullWidget.classList.add(CustomClass.MAIN_BLOCK);

    const container = document.createElement("div");
    container.className = fullWidgetContainerStyles.default;
    container.classList.add(CustomClass.CONTAINER);
    container.dataset.nameSpace = "dentolo";

    const closeButton = document.createElement("div");
    closeButton.className = closeButtonStyles.default;
    closeButton.dataset.nameSpace = "dentolo";
    closeButton.classList.add(CustomClass.CLOSE_BUTTON);
    closeButton.onclick = () => this.clickEmitter.emit(WidgetEvent.CLOSE_WIDGET);

    const mainButton = document.createElement("button");
    mainButton.className = mainButtonStyles.default;
    mainButton.dataset.nameSpace = "dentolo";
    mainButton.textContent = this.options?.buttonText || null;
    mainButton.classList.add(CustomClass.MAIN_BUTTON);
    mainButton.onclick = (event) => this.clickEmitter.emit(WidgetEvent.CALL_QUIZ, event);

    const offer = document.createElement("div");
    offer.className = offerStyles.default;
    offer.dataset.nameSpace = "dentolo";

    if (typeof this.options?.offerText == "string") {
      offer.innerHTML = this.options?.offerText?.replace(/\n/g, "<br />") || "";
    }

    if (typeof this.options?.offerText == "object") {
      const option = this.options?.offerText;
      offer.innerHTML = this.defineOption(option).replace(/\n/g, "<br />") || "";

      window.addEventListener("resize", () => {
        offer.innerHTML = this.defineOption(option).replace(/\n/g, "<br />") || "";
      });
    }

    offer.classList.add(CustomClass.OFFER);
    offer.onclick = (event) => this.clickEmitter.emit(WidgetEvent.CALL_QUIZ, event);

    var image = document.createElement("div");

    const mapClassNametoElements: Record<string, HTMLElement> = {
      mainBlock: this.fullWidget,
      container: container,
      image: image,
      offer: offer,
      closeButton: closeButton,
      mainButton: mainButton
    };

    const addStyles = () => {
      for (let width in this.options.appearance) {
        if (window.innerWidth > Number(width)) {
          const style = this.options.appearance[Number(width)].style;
          const hoverStyle = this.options.appearance[Number(width)].hoverStyle;

          if (style) {
            for (let field in style) {
              if (field == "miniWidget") continue;
              for (const property in style[field]) {
                mapClassNametoElements[field].style[property] = (style[field] as CSSStyleDeclaration)[property];
              }
            }
          }

          if (hoverStyle) {
            for (let field in hoverStyle) {
              if (field == "miniWidget") continue;
              for (const property in hoverStyle[field]) {
                mapClassNametoElements[field].onpointerenter = () => {
                  mapClassNametoElements[field].style[property] = (hoverStyle[field] as CSSStyleDeclaration)[property];
                }

                mapClassNametoElements[field].onpointerleave = () => {
                  mapClassNametoElements[field].style[property] = (style[field] as CSSStyleDeclaration)[property];
                }
              }
            }
          }
        }
      }
    }

    window.addEventListener("resize", () => addStyles());
    addStyles();

    if (this.options?.imageSrc) {
      image.className = imageStyles.default;
      image.dataset.nameSpace = "dentolo";
      image.onclick = (event) => this.clickEmitter.emit(WidgetEvent.CALL_QUIZ, event);
      image.classList.add(CustomClass.IMAGE);

      if (typeof this.options?.imageSrc == "string") {
        image.style.backgroundImage = `url(${this.options.imageSrc})`;
      }

      if (typeof this.options?.imageSrc == "object") {
        image.style.backgroundImage = `url(${this.defineOption(this.options.imageSrc)})`;
      }

      window.addEventListener("resize", () => {
        if (typeof this.options?.imageSrc == "object") {
          image.style.backgroundImage = `url(${this.defineOption(this.options.imageSrc)})`;
        }
      });

      if (image) container.appendChild(image);
    }

    container.appendChild(offer);
    container.appendChild(mainButton);
    this.fullWidget.appendChild(container);
    this.fullWidget.appendChild(closeButton);
    document.body.appendChild(this.fullWidget);
  }


  private defineOption(sizes: Record<number, string>) {
    let imageSrc: string = "";

    Object.keys(sizes).forEach(key => {
      if (window.innerWidth > Number(key)) imageSrc = sizes[key];
    });

    return imageSrc;
  }

  public show() {
    this.fullWidget.style.bottom = "0px";
  }

  public hide() {
    this.fullWidget.style.bottom = - this.fullWidget.clientHeight + "px";
  }
}
